import React from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative flex items-center px-6 pt-12 pb-24 md:pt-20 md:pb-32 background-grid overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-2 md:px-6 w-full grid lg:grid-cols-[2fr_1fr] gap-12 items-center">
        <div className="backdrop-blur-md bg-white/5 border border-gray-400/30 rounded-3xl p-8 md:p-12 shadow-xl w-full">
          <span className="text-xs uppercase tracking-[0.3em] text-gray-500 animate-fade-in-up">
            AI Research for Mental Health
          </span>

          <h1 className="text-4xl md:text-6xl font-light leading-tight mt-4 mb-6 animate-fade-in-up animation-delay-200">
            Rebuilding Mental-Health <br /> through AI and ML
          </h1>

          <p className="text-gray-800 text-lg leading-relaxed mb-8 max-w-2xl animate-fade-in-up animation-delay-400">
            Cognitics is an AI research organization developing machine learning and
            data-driven systems to fundamentally change how mental health is understood,
            analyzed, and supported at scale.
          </p>

          <div className="flex flex-wrap gap-4 animate-fade-in-up animation-delay-600">
            <Link to="/bloora" className="btn-primary">
              Explore Bloora
            </Link>
            <Link to="/early-access" className="btn-ghost">
              Apply for early access
            </Link>
          </div>
        </div>

        <div className="hidden lg:flex lg:justify-end">
          <img
            src="/logo_new_v2.png"
            alt="Cognitics"
            className="w-80 md:w-[420px] opacity-90 drop-shadow-2xl animate-float-glow"
          />
        </div>
      </div>
    </section>
  );
}
